export default __webpack_public_path__ + "static/media/location-pin.ceda264d.svg";